import { render } from "./DragAndDropUpload.vue?vue&type=template&id=36cb126a&scoped=true"
import script from "./DragAndDropUpload.vue?vue&type=script&lang=js"
export * from "./DragAndDropUpload.vue?vue&type=script&lang=js"

import "./DragAndDropUpload.vue?vue&type=style&index=0&id=36cb126a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cb126a"]])

export default __exports__